// @flow

/**
 * Used to attach handlers in client/src/scripts/blocks/header.jsx
 */
export const CART_BUTTON = 'header-cart-button';
export const USER_ACCOUNT_BUTTON = 'header-user-account';
export const SIDE_BLOCK = 'header-side-block';
export const LOGO = 'header-logo';
export const CUSTOM_BUTTON_SECTION = 'header-custom-buttons';
export const LOCALE_SELECT = 'header-locale-select';
export const BURGER_MENU_BUTTON = 'burger-menu-button';
export const BURGER_MENU_LIST = 'burger-menu-list';
